import { Box, BoxProps, Flex, Image } from '@chakra-ui/react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { BaseNav, useAuth, useNavItemStore } from '@cksoftware/react-base';
import logo from '../../assets/logo.png';
import { ConductionAuctionButton } from '../../features/header/components/conductionAuctionButton';
import { useProfileItems } from './useProfileItems';
import { DlmsUser, getCurrentProfile } from '../../globalModels/user/dlmsUser';
import { ApplicationRoutes } from '../../constants/appRoutes';
import { useEffect } from 'react';

type NarrowLayoutProps = {
  containerProps?: BoxProps;
};

export const FlexLayout = (props: NarrowLayoutProps) => {
  const navigate = useNavigate();
  const routeNav = useNavItemStore((state) => {
    return { items: state.getDefault(), get: state.get };
  });

  const auth = useAuth<DlmsUser>();
  const profileItems = useProfileItems();

  useEffect(() => {
    if (auth.isAuthenticated === false) {
      navigate(ApplicationRoutes.account.login);
    }
  });

  const currentProfile = getCurrentProfile(auth.user);

  return (
    <Flex as='section' direction={'column'} height='100vh' overflowY='auto'>
      <BaseNav.Header
        navItems={routeNav.items}
        profileItems={profileItems}
        avatarName={`${currentProfile?.FirstName} ${currentProfile?.LastName}`}
        logo={
          <Link to={'/'}>
            <Image height={['65px']} src={logo} alt='logo' />
          </Link>
        }>
        <ConductionAuctionButton />
      </BaseNav.Header>

      <Box
        w={['100%', '100%', '100%', '90%']}
        margin={'auto'}
        paddingLeft={'5px'}
        paddingRight={'5px'}
        paddingTop={'10px'}
        maxH={'calc(100vh - 70px)'}
        flex={1}
        {...props.containerProps}>
        <Outlet />
      </Box>
    </Flex>
  );
};
